module.exports = __webpack_public_path__ + "static/media/iStock-685797114.73da8ac2.jpg";